import axios from "../../utils/axios";

// 分区管理
export function getList(query) {
    return axios({
        url: "subareaManage/getList",
        method: "get",
        params: query
    });
}

//分区删除
export function deleteSubarea(data) {
    return axios({
        url: "subareaManage/delete",
        method: "post",
        data: data
    });
}
// 分区增加
export function addSubarea(data) {
    return axios({
        url: "subareaManage/update",
        method: "post",
        data: data
    });
}

// 分区修改
export function updateSubarea(data) {
    return axios({
        url: "subareaManage/update",
        method: "post",
        data: data
    });
}

// 查询物流
export function getExpress() {
    return axios({
        url: "subareaManage/getExpress",
        method: "get"
    });
}

// 查询详情
export function getSubareaInfo(data) {
    return axios({
        url: "subareaManage/getInfo",
        method: "get",
        params: data
    });
}

